import { ReplacementCodes } from "apollo/data"



export const useReplacementReasons = (variables?: any) => {
    const { page, pageSize, search } = variables || { page: 1, pageSize: 10, search: "" };
    const start = (parseInt(page) - 1) * pageSize;
    const end = start + pageSize;
    const items = ReplacementCodes.filter(el => {
        return el.code.toLowerCase().includes(search.toLowerCase()) ||
            el.name.toLowerCase().includes(search.toLowerCase())
    }).slice(start, end);
    return {
        reasons: items,
        count: ReplacementCodes.filter(el => {
            return el.code.toLowerCase().includes(search.toLowerCase()) ||
                el.name.toLowerCase().includes(search.toLowerCase())
        }).length
    }
}